import * as React from "react";
import type { CSSProperties } from "react";
import Box from "@mui/material/Box";
import { Label } from "@fluentui/react/lib/Label";
import type { BolDetailsFieldName } from "./bolDetailsFormTypes";

const labelStyles = {
  root: {
    fontSize: "12px",
    fontWeight: 500,
    color: "#605e5c",
    marginBottom: "4px",
  },
} as const;

const timeStyles = {
  timeFieldCol: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    minWidth: 0,
    marginBottom: "8px",
  },
  timeInput: {
    width: "100%",
    boxSizing: "border-box",
    padding: "6px 8px",
    fontSize: "13px",
    lineHeight: "18px",
    fontWeight: 400,
    color: "#323130",
    borderRadius: "5px",
    borderWidth: "2px",
    borderStyle: "solid",
    fontFamily: "inherit",
    backgroundColor: "#fff",
  },
};

export function BolTimeInput(props: {
  label: string;
  name: BolDetailsFieldName;
  value: string;
  onChange: (name: BolDetailsFieldName, value: string) => void;
  onBlur?: () => void;
  required?: boolean;
  errorMessage?: string;
  inferred?: boolean;
}): React.ReactElement {
  const { label, name, value, onChange, onBlur, required, errorMessage, inferred } = props;
  const hasError = !!errorMessage;
  const inputId = `ltl-bol-time-${String(name)}`;

  return (
    <Box sx={timeStyles.timeFieldCol}>
      <Label htmlFor={inputId} required={!!required} styles={labelStyles}>
        {label}
      </Label>
      <input
        id={inputId}
        type="time"
        name={name}
        value={value}
        onChange={(e) => onChange(name, e.target.value)}
        onBlur={onBlur}
        style={
          {
            ...timeStyles.timeInput,
            borderColor: hasError ? "#d13438" : "#eff1f3",
            backgroundColor: inferred && !hasError ? "#fff8e6" : "#ffffff",
          } as CSSProperties
        }
      />
      {errorMessage ? (
        <span style={{ color: "#a4262c", fontSize: 12, display: "block", marginTop: 4 }}>
          {errorMessage}
        </span>
      ) : null}
    </Box>
  );
}
